module.exports = __webpack_public_path__ + "static/media/1.986520c7.png";